import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// import { useLoadAuthUser } from '../../hooks/authhooks';
import LoadingScreen from '../../pages/shared/LoadingScreen';
// import homecook_logo from '../../assets/img/homecook_logo.png'
import { SelfServiceDetailsSchema, RegisteredPartner, SelfServiceOrganizationSchema } from '../../data/types';
import { useSelfServiceRegistration } from '../../hooks/communityhook';
// import { useAuthState } from '../../../contexts/authcontext'
// import SelfServiceAdmin from './SelfServiceAdmin';
// Sample companies data - in a real app, this would come from an API

// type AccessOrganizationSchema = {
//   id: string;
//   name: string;
//   booth: string;
// }

// export const ORGANIZATIONS: AccessOrganizationSchema[] = [
//   { id: '1', name: 'Amerigroup', booth: 'A1' },
//   { id: '2', name: 'BCFSN', booth: 'A2' },
//   { id: '3', name: 'CM Felder', booth: 'A3' },
//   { id: '4', name: 'DC Gov\'t', booth: 'A4' },
//   { id: '5', name: 'DPR Environmental Division', booth: 'A5' },
//   { id: '6', name: 'Children\'s National', booth: 'B1' },
//   { id: '7', name: 'East River Collaborative', booth: 'B2' },
//   { id: '8', name: 'Earth Conservation Corp', booth: 'B3' },
//   { id: '9', name: 'DC Central Kitchen', booth: 'B4' },
//   { id: '10', name: 'The Links', booth: 'B5' },
//   { id: '11', name: 'Common Good City Farms', booth: 'C1' },
//   { id: '12', name: 'EOM / DC Food Policy / Office of Planning', booth: 'C2' },
//   { id: '13', name: 'DC Legal Aid', booth: 'C3' },
//   { id: '14', name: 'HomeCook', booth: 'C4' },
//   { id: '15', name: 'SWAP DC', booth: 'C5' }
// ];
const SIGN_IN_METHODS = [
  { id: 'email', label: 'Email' },
  { id: 'phone', label: 'Phone Number' }
];



// interface EventDetailsMap {
//   [key: string]: EventDetailsSchema;
// }

// // Event details mapping
// const EVENT_DETAILS: EventDetailsMap = {
//   'springfest': {
//     name: 'SpringFest 2025',
//     logo: 'https://dreamingoutloud.org/wp-content/uploads/2024/10/Dreaming-Out-Loud-Home-Logo-.webp',
//     organizer: 'Dreaming Out Loud',
//     organizerUrl: 'https://dreamingoutloud.org',
//     date: 'April 15, 2025',
//     startTime: '10:00 AM',
//     endTime: '6:00 PM'
//   },
//   'summerfest': {
//     name: 'SummerFest 2025',
//     logo: 'https://dccentralkitchen.org/wp-content/uploads/2022/03/DCCentralKitchen_logo-hi-res-75x75.png',
//     organizer: 'DC Central Kitchen',
//     organizerUrl: 'https://dccentralkitchen.org/',
//     date: 'July 20, 2025',
//     startTime: '9:00 AM',
//     endTime: '5:00 PM'
//   },
//   // Add more events as needed
// };






type SelfServiceRegistrationFormProps = {
  selfServiceDetails: SelfServiceDetailsSchema; 
  isLoggedIn?: boolean;
  closeAppModal?: () => void;
}

const SelfServiceRegistrationForm: React.FC<SelfServiceRegistrationFormProps> = ({selfServiceDetails, isLoggedIn, closeAppModal}) => {

  // const navigate = useNavigate();
  const { event } = useParams();
  // const { registerBusiness, isLoading } = useLoadAuthUser();
  const { addSelfServiceRegistrationData, isLoading } = useSelfServiceRegistration(selfServiceDetails?.id);

  const defaultPartner = {
    organization: '',
    email: '',
    phone: '',
    event_code: event || '',
    booth: '',
    team_size: 1,
    first_name: '',
    last_name: '',
    sign_in_method: 'email',
    registration_type: 'individual',
    partner_type: 'event',
    // active: false
  }
  const [formData, setFormData] = useState<RegisteredPartner>(defaultPartner);

  const [showMessage, setShowMessage] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      // formData.community_id = selfServiceDetails.community_id || '';
      const result = await addSelfServiceRegistrationData(selfServiceDetails.community_id || '', formData);
      if (result){
        setIsSuccess(true);
        setShowMessage(true);
        setFormData(defaultPartner);
        if (isLoggedIn && closeAppModal) {
          setFormData(defaultPartner);
          closeAppModal();
        } 
      } else {
        console.error('Registration failed:');
        setIsSuccess(false);
        setShowMessage(true);
      }
    } catch (error) {
      console.error('Registration failed:', error);
      setIsSuccess(false);
      setShowMessage(true);
    }
  };


    // Keep event code in sync with URL parameter
    useEffect(() => {
      if (event) {
        setFormData(prev => ({
          ...prev,
          event_code: event
        }));
        // setError('');
      }
    }, [event]);
  
    useEffect(() => {
      if (selfServiceDetails?.id) {
        setFormData(prev => ({ ...prev, event_code: selfServiceDetails.id }));
      }
    }, [selfServiceDetails?.id]);
  
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      const { name, value } = e.target;
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    };
  
    const handleCompanySelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
      const selectedCompany = selfServiceDetails?.organizations.find((organization: SelfServiceOrganizationSchema) => organization.name === e.target.value);
      if (selectedCompany) {
        setFormData(prev => ({
          ...prev,
          organization: selectedCompany.name,
          booth: selectedCompany.booth
        }));
      }
    };




  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <form className="space-y-6" onSubmit={handleSubmit}>
        {showMessage && (
          <div className={`font-open-sans p-4 rounded-lg ${isSuccess ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'} mb-6`}>
            <div className="flex">
              <div className="flex-shrink-0">
                {isSuccess ? (
                  <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                ) : (
                  <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                )}
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium">
                  {isSuccess ? "Registration successful!" : "Registration failed. Please contact event organizer."}
                </p>
              </div>
              <div className="ml-auto pl-3">
                <div className="-mx-1.5 -my-1.5">
                  <button
                    type="button"
                    onClick={() => setShowMessage(false)}
                    className={`inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                      isSuccess 
                        ? 'text-green-500 hover:bg-green-100 focus:ring-green-600' 
                        : 'text-red-500 hover:bg-red-100 focus:ring-red-600'
                    }`}
                  >
                    <span className="sr-only">Dismiss</span>
                    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div>
          <label htmlFor="event_code" className="block text-sm font-medium text-primary-200 font-raleway">
            Access Code
          </label>
          <input
            id="event_code"
            type="text"
            name="event_code"
            disabled
            readOnly
            value={formData.event_code}
            onChange={handleChange}
            className="mt-1 font-open-sans block w-full border-[1px] border-[#E9E9E9] rounded-lg shadow-sm py-3 px-4 bg-back-500 text-primary-200 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300"
          />
        </div>

        <div>
          <label htmlFor="companySelect" className="block text-sm font-semibold text-primary-200 font-raleway">
            Select Organization
          </label>
          <select
            id="companySelect"
            name="organization"
            value={formData.organization}
            required
            onChange={handleCompanySelect}
            className="mt-1 font-open-sans block w-full pl-3 pr-10 py-3 text-base border-[1px] border-[#E9E9E9] focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 sm:text-sm rounded-lg"
          >
            <option value="">-- Select your organization --</option>
            {selfServiceDetails?.organizations && selfServiceDetails?.organizations.map((organization: SelfServiceOrganizationSchema, i: number) => (
              <option key={i} value={organization.name}>
                {organization.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="boothNumber" className="block text-sm font-semibold text-primary-200 font-raleway">
            Booth Number
          </label>
          <input
            id="boothNumber"
            type="text"
            name="boothNumber"
            value={formData.booth}
            readOnly
            disabled
            className="mt-1 font-open-sans block w-full border-[1px] border-[#E9E9E9] rounded-lg shadow-sm py-3 px-4 bg-back-500 text-primary-200 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-primary-200 font-raleway">
            Registration Type
          </label>
          <div className="mt-2 space-x-4">
            <label className="inline-flex items-center font-open-sans">
              <input
                type="radio"
                name="registration_type"
                value="individual"
                checked={formData.registration_type === 'individual'}
                onChange={handleChange}
                className="h-4 w-4 text-primary-300 focus:ring-primary-300 border-[1px] border-[#E9E9E9]"
              />
              <span className="ml-2 text-sm text-primary-200 font-open-sans">Individual</span>
            </label>
            <label className="inline-flex items-center font-open-sans">
              <input
                type="radio"
                name="registration_type"
                value="team"
                checked={formData.registration_type === 'team'}
                onChange={handleChange}
                className="h-4 w-4 text-primary-300 focus:ring-primary-300 border-[1px] border-[#E9E9E9]"
              />
              <span className="ml-2 text-sm text-primary-200 font-open-sans">Team</span>
            </label>
          </div>
        </div>

        {formData.registration_type === 'team' && (
          <div className="flex space-x-4">
            <div className="flex-1">
              <label htmlFor="team_size" className="block text-sm font-semibold text-primary-200 font-raleway">
                Team Size
              </label>
              <input
                id="team_size"
                type="number"
                name="team_size"
                required
                min="2"
                value={formData.team_size}
                onChange={handleChange}
                className="mt-1 font-open-sans block w-full border-[1px] border-[#E9E9E9] rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
                placeholder="Enter number of team members"
              />
            </div>
            <div className="flex-1 font-open-sans">
              <label className="block text-sm font-semibold text-primary-200 opacity-0">
                &nbsp;
              </label>
              <div className="mt-1 flex items-center h-[46px] text-sm text-back-200">
                Minimum 2 team members required
              </div>
            </div>
          </div>
        )}

        <div className="flex space-x-4">
          <div className="flex-1">
            <label htmlFor="first_name" className="block text-sm font-semibold text-primary-200 font-raleway">
              {formData.registration_type === 'team' ? 'Contact First Name' : 'First Name'}
            </label>
            <input
              id="first_name"
              type="text"
              name="first_name"
              required
              value={formData.first_name}
              onChange={handleChange}
              className="mt-1 font-open-sans block w-full border-[1px] border-[#E9E9E9] rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
            />
          </div>
          <div className="flex-1">
            <label htmlFor="last_name" className="block text-sm font-semibold text-primary-200 font-raleway">
              {formData.registration_type === 'team' ? 'Contact Last Name' : 'Last Name'}
            </label>
            <input
              id="last_name"
              type="text"
              name="last_name"
              required
              value={formData.last_name}
              onChange={handleChange}
              className="mt-1 font-open-sans block w-full border-[1px] border-[#E9E9E9] rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
            />
          </div>
        </div>

        <div className="flex space-x-4">
          <div className="flex-1">
            <label htmlFor="email" className="block text-sm font-semibold text-primary-200 font-raleway">
              {formData.registration_type === 'team' ? 'Contact Email Address' : 'Email Address'}
            </label>
            <input
              id="email"
              type="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="mt-1 font-open-sans block w-full border-[1px] border-[#E9E9E9] rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
            />
          </div>
          <div className="flex-1">
            <label htmlFor="phone" className="block text-sm font-semibold text-primary-200 font-raleway">
              {formData.registration_type === 'team' ? 'Contact Phone Number' : 'Phone Number'}
            </label>
            <input
              id="phone"
              type="tel"
              name="phone"
              required={formData.sign_in_method === 'phone'}
              value={formData.phone}
              onChange={handleChange}
              className="mt-1 font-open-sans block w-full border-[1px] border-[#E9E9E9] rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-primary-200 font-raleway">
            Preferred Contact Method
          </label>
          <div className="mt-2 space-x-4">
            {SIGN_IN_METHODS.map(method => (
              <label key={method.id} className="inline-flex items-center font-open-sans">
                <input
                  type="radio"
                  name="sign_in_method"
                  value={method.id}
                  checked={formData.sign_in_method === method.id}
                  onChange={handleChange}
                  className="h-4 w-4 font-open-sans text-primary-300 focus:ring-primary-300 border-[1px] border-[#E9E9E9]"
                />
                <span className="ml-2 text-sm text-primary-200">{method.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div>
          <button
            type="submit"
            className="w-full font-open-sans flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-semibold text-white bg-primary-200 hover:bg-primary-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-300 transition-colors"
          >
            Complete Registration
          </button>
        </div>
      </form>  
    </>
  )
}

export default SelfServiceRegistrationForm; 